import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { Tooltip, type TooltipProps } from '@ui/Tooltip';
import { Box } from '@mui/material';

const useStyles = makeStyles()(() => ({
  root: {
    position: 'absolute',
    right: 0,
    top: 0,
    left: 0,
    bottom: 0,
    inset: 0,
  },
}));

export type BackdropTooltipProps = Omit<TooltipProps, 'children'> & {
  zIndex?: number;
};

export const BackdropTooltip: React.FC<BackdropTooltipProps> = ({
  zIndex = 0,
  ...tooltipProps
}) => {
  const { classes } = useStyles();

  return (
    <Tooltip {...tooltipProps}>
      <Box
        aria-hidden
        className={classes.root}
        sx={{
          zIndex: zIndex,
        }}
      />
    </Tooltip>
  );
};
